import moment from "moment/moment";

const colors = ['#0094FF', '#AA00FF', '#00CCCC', '#FF4D88'];

const toolbarOptions = {
  tools: {
    zoomin: '<img src="/img/chart-zoom-in.png" style="width: 40px">',
    zoomout: '<img src="/img/chart-zoom-out.png" style="width: 40px">',
    zoom: false,
    pan: '<img src="/img/chart-move.png" style="width: 40px">',
    reset: '<img src="/img/chart-home.png" style="width: 40px">',
    download: '<img src="/img/chart-export.png" style="width: 40px">',
  },
};

export const lineChartOptions = {
  colors,
  chart: {
    toolbar: {
      ...toolbarOptions,
    },
  },
  legend: {
    horizontalAlign: 'left',
    markers: {
      customHTML: () => '<img src="/img/chart-marker.svg" class="tw-h-3 tw-w-3 tw-m-auto"/>',
      width: '20px',
      height: '20px',
      radius: '5px',
    },
    itemMargin: {
      horizontal: 5,
      vertical: 20
    },
  },
  stroke: {
    curve: 'smooth',
  },
  xaxis: {
    tooltip: {
      enabled: false,
    },
  },
  states: {
    active: {
      filter: {
        type: 'none',
      },
    },
  },
  hover: {
    filter: {
      type: 'none',
    },
  },
};

export const barChartOptions = {
  colors,
  chart: {
    toolbar: {
      ...toolbarOptions,
    },
  },
  tooltip: {
    custom: function({series, seriesIndex, dataPointIndex, w}) {
      return '<div class="apex-custom-tooltip">' +
        '<span>' + series[seriesIndex][dataPointIndex] + '</span>' +
        '</div>';
    },
  },
  states: {
    active: {
      filter: {
        type: 'none',
      },
    },
    hover: {
      filter: {
        type: 'none',
      },
    },
  },
};

export const getXaxisDates = (data, compareData) => {
  const values = (data ?? []).map((row => row.date));
  if (values.length >= (compareData ?? []).length) {
    return values;
  }

  // If our compare data is longer we need to pad the x-axis
  while (values.length < compareData.length) {
    const lastDate = [...values].pop();
    values.push(moment(lastDate).add(1, 'day').format('YYYY-MM-DD'));
  }

  return values;
};

